


















































































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import Arrow from '@/components/icons/ArrowLink.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import CalendarIcon from '@/components/icons/Calendar.vue';
import SuccessIcon from '@/components/icons/SuccessSolid.vue';
import ShareCampaign from '@/components/ShareCampaign/ShareCampaign.vue';
import PercentageCircle from '@/components/icons/PercentageCircle.vue';
import Typography from '@/components/atoms/Typography/Typography.vue';
import SellCoinsService from '@/api/SellCoinsService';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import GhostButton from '@/components/molecules/GhostButton/GhostButton.vue';
import SocialMediaIcon from '@/components/icons/SocialMedia.vue';
import Radio from '@/components/molecules/Radio/Radio.vue';
import PercentageCircleIcon from '@/components/icons/PercentageCircle.vue';
import BusinessService from '@/api/BusinessService';
import { EAutomaticCampaignName, EIncentiveType } from '@/models/sell-coins';
import { DashboardScreen } from '@/api/enums/dashboard-screen.enum';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    Arrow,
    FilledButton,
    SuccessIcon,
    ShareCampaign,
    CalendarIcon,
    CoinsIcon,
    GhostButton,
    PercentageCircle,
    PercentageCircleIcon,
    SocialMediaIcon,
    Typography,
    Radio
  }
})
export default class SellCoinsRatioAdjustModal extends Vue {
  @Prop() activeCampaignData!: any;
  @Prop() newCampaignData!: any;
  @Prop() onSuccess!: (message: string) => Promise<void>;
  campaignName: any = EAutomaticCampaignName;
  businessService = new BusinessService();
  sellCoinsService = new SellCoinsService();
  loading = false;
  loadingDeactivate = false;

  handleClose() {
    eventBus.$emit('closeModal');
  }

  async handleDisableSellCoins() {
    this.loadingDeactivate = true;
    const response = await this.businessService.updateSellCoins(
      false,
      DashboardScreen.Dashboard
    );

    this.$store.dispatch('business/SET_BUSINESS_INFO', {
      ...this.businessInfo,
      sellCoins: response.data.sellCoins
    });
    await this.onSuccess(`${this.tPrefix}.disabled`);
    this.loadingDeactivate = false;
    eventBus.$emit('closeModal');
  }

  async handleConfirm() {
    this.loading = true;
    await this.sellCoinsService.deactivateActiveCampaign();
    await this.sellCoinsService.createSellingCoinsCampaign({
      ...this.newCampaignData,
      name: EAutomaticCampaignName.loyalt,
      incentiveType: EIncentiveType.BONUS,
      automaticallyCreated: true
    });
    await this.onSuccess(`${this.tPrefix}.migrationCompleted`);
    this.loading = false;
    this.handleClose();
  }

  mounted() {
    window.addEventListener('popstate', () => {
      this.handleClose();
    });
  }

  formatNumber(number: string) {
    const num = parseFloat(number);
    return num % 1 === 0 ? Math.floor(num) : num.toFixed(2);
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  get tPrefix() {
    return 'sellCoins.modals.ratioAdjust';
  }

  get imgUrl() {
    return require(`@/assets/img/reward-onboarding/circle-arrow-right.png`);
  }

  get title() {
    return `${this.$t(`${this.tPrefix}.title`)}`;
  }

  get description() {
    return `${this.$t(`${this.tPrefix}.description`)}`;
  }

  get description2() {
    return `${this.$t(`${this.tPrefix}.description2`, {
      ratio: this.newCampaignData.incentiveValue
    })}`;
  }
}
